/**
 * Solanaland
 *
 * Author: Phia Nasol
 * Company: Digiteer Inc.
 *
 * https://www.digiteer.digital/
 *
 */

import { api } from "core/api";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { items_admin_item_inventories_path } from "routes";
import ItemInventory from "./ItemInventory";

type WarehouseInventoriesProps = {
  warehouses: Array<Record<string, unknown>>;
  policy: Record<string, boolean>;
};

const WarehouseInventories = ({ warehouses, actions, policy, adjustment_reasons }: WarehouseInventoriesProps): JSX.Element => {
  const [isItemsLoading, setIsItemsLoading] = React.useState(false);
  const [items, setItems] = React.useState([]);

  const getInventoryItems = async () => {
    try {
      setIsItemsLoading(true);
      const response = await api.get(items_admin_item_inventories_path({ format: "json" }));
      setItems(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsItemsLoading(false);
    }
  };

  React.useEffect(() => {
    getInventoryItems();
  }, []);

  return (
    <React.StrictMode>
      <Tabs className="card" selectedTabClassName="project-tab__link project-tab__link--active">
        <Container fluid={true}>
          <Row className="d-flex align-items-baseline">
            <Col>
              <TabList className="card__header" style={{ padding: 0 }}>
                <Col className="d-flex justify-content-start">
                  {warehouses.map((warehouse) => {
                    return (
                      <Tab key={warehouse.id} data-warehouse-id={warehouse.id} className="project-tab__link">
                        {warehouse.name}
                      </Tab>
                    );
                  })}
                </Col>
              </TabList>
            </Col>
          </Row>
          {warehouses.map((warehouse) => {
            return (
              <TabPanel key={warehouse.id}>
                <ItemInventory
                  warehouseId={warehouse.id}
                  warehouses={warehouses}
                  actions={actions}
                  adjustment_reasons={adjustment_reasons}
                  isItemsLoading={isItemsLoading}
                  items={items}
                  policy={policy}
                  onSave={(_itemInventory) => {
                    console.debug("Intentionally left empty");
                  }}
                />
              </TabPanel>
            );
          })}
        </Container>
      </Tabs>
    </React.StrictMode>
  );
};

export default WarehouseInventories;
